/// <reference path="../assets.d.ts" />
import { Asset } from 'expo-asset';
import type { ImageSource } from '../image.types';
import officeDarkAsset from './office-dark.webp';

// Web variant. The bundled WebP's URL, which the image layer fetches.
export const officeDark: ImageSource = Asset.fromModule(officeDarkAsset).uri;
